import React from 'react';

import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';

import Header from '../components/commons/header';
import Footer from '../components/commons/footer';
import ScrollToTop from '../domain/ScrollToTop';
import Home from '../components/home';
import NotFound from '../components/notFound';
import AboutUs from '../components/aboutUs';
import OurWork from '../components/ourWork';
import News from '../components/news';
import Careers from '../components/careers';
import Contact from '../components/contact';
import NewsContent from '../components/newsContent';
import OurWorkContent from '../components/ourWorkContent';
import Sellers from '../components/sellers';
import Terms from '../components/terms';
import TermsAndConditions from '../components/termsAndConditions';
import TermsAndConditionsCategories from '../components/termsAndConditionsCategories';
import TermsAndConditionsContent from '../components/termsAndConditionsContent';
import Academy from '../components/academy';


// import PrivacyPolicy from '../components/privacyPolicy';
// import TermsOfUse from '../components/termsOfUse';
// import BrandSafetyPolicy from '../components/brandSafetyPolicy';

export default function AppRoutes(props) {
    return (
        <Router>
            <Header />
            <ScrollToTop />
            <Switch>

                <Route
                    exact={true}
                    path="/"
                    component={Home}
                />

                <Route
                    exact={true}
                    path="/home"
                    component={Home}
                />
                <Route
                    exact={true}
                    path="/aboutUs"
                    component={AboutUs}
                />
                <Route
                    exact={true}
                    path="/ourWork"
                    component={OurWork}
                />
                <Route
                    exact={true}
                    path="/news"
                    component={News}
                />
                <Route
                    exact={true}
                    path="/careers"
                    component={Careers}
                />
                <Route
                    exact={true}
                    path="/contact"
                    component={Contact}
                />
                <Route
                    exact={true}
                    path="/newsContent/:url"
                    component={NewsContent}
                />
                <Route
                    exact={true}
                    path="/ourWorkContent/:url"
                    component={OurWorkContent}
                />

                <Route
                    exact={true}
                    path="/sellers.json"
                    component={Sellers}
                />

                <Route
                    exact={true}
                    path="/terms"
                    component={Terms}
                />

                <Route
                    exact={true}
                    path="/terms&Conditions"
                    component={TermsAndConditions}
                />

                <Route
                    exact={true}
                    path="/terms&Conditions_categories/:url"
                    component={TermsAndConditionsCategories}
                />

                <Route
                    exact={true}
                    path="/terms&Conditions_content/:url"
                    component={TermsAndConditionsContent}
                />
                 <Route
                    exact={true}
                    path="/academy"
                    component={Academy}
                />
                {/* <Route
                    exact={true}
                    path="/newsNewsletter"
                    component={NewsNewsletter}
                /> */}

                {/* <Route
                    exact={true}
                    path="/privacypolicy"
                    component={PrivacyPolicy}
                />

                <Route
                    exact={true}
                    path="/termsofuse"
                    component={TermsOfUse}
                />

                <Route
                    exact={true}
                    path="/brandsafetypolicy"
                    component={BrandSafetyPolicy}
                /> */}
                <Route
                    exact={true}
                    path="/notFound"
                    component={NotFound}
                />
                <Redirect to="/notFound" />

            </Switch>
            <Footer />
        </Router>
    );
}